import apiClient from "../../client/api-client";
import { endpoints } from "../../api";

export const adminLogin = (data) =>
  apiClient({ url: endpoints.ADMIN_LOGIN, data, method: "POST" });

export const adminLogout = () =>
  apiClient({ url: endpoints.ADMIN_LOGOUT, method: "POST" });

export const adminForgotPassword = (data) =>
  apiClient({ url: endpoints.ADMIN_FORGOT_PASSWORD, data, method: "POST" });

export const adminValidateResetToken = (token) =>
  apiClient({ url: endpoints.ADMIN_VALIDATE_RESET_TOKEN(token), method: "GET" });

export const adminResetPassword = (token, data) =>
  apiClient({ url: endpoints.ADMIN_RESET_PASSWORD(token), data, method: "POST" });

export const getAdminProfile = () =>
  apiClient({ url: endpoints.GET_ADMIN_PROFILE, method: "GET" });

export const updateAdminProfile = (data) =>
  apiClient({ url: endpoints.UPDATE_ADMIN_PROFILE, data, method: "PATCH" });

export const changeAdminPassword = (data) =>
  apiClient({ url: endpoints.CHANGE_ADMIN_PASSWORD, data, method: "PATCH" });
